  function loadJQuery() {
    var waitForLoad = function () {
      if (typeof jQuery != "undefined") {
        $('.toggle-button').on('click', (event) => {
          event.preventDefault();
          var $this = $(event.target);
          var isExpanded = $this.attr('aria-expanded');

          if (typeof isExpanded === 'undefined') {
            $this = $this.parent();
            isExpanded = $this.attr('aria-expanded');
          }

          if (isExpanded === 'false') {
            $('.toggle-button').attr('aria-expanded', false);
            $this.attr('aria-expanded', true);

            var handle = $this.attr('data-handle');
            var $slider = $('.option-list').filter((i, s) => {
              return $(s).attr('data-handle') === handle;
            });
            var $backgroundContainer = $('.background-container');

            //set toggle button background
            if ($this.next().length) {
              $backgroundContainer.removeClass('with-transform');
            } else {
              $backgroundContainer.addClass('with-transform');
            }

            $('.option-list').addClass('inactive');
            $slider.removeClass('inactive');
          }
        });


        $('body').on('click', '.size-button', (event) => {
          event.preventDefault();
          var $this = $(event.target);
          if (typeof $this.attr('pre-order') !== undefined) {
            $('.pre-order-message').attr('hidden', '');
            $this.next().removeAttr('hidden');
          }

          // add to cart, trigger drawer
          var id = $this.attr('data-id');
          var isPreOrder = typeof $this.attr('pre-order') !== 'undefined';
          var formData = {
            'items': [{
              'id': id,
              'quantity': 1
              }]
          };
          
          if (isPreOrder) {
            var preOrderMsg = $this.next().text();
            formData.items[0]['properties'] = {
              [preOrderMsg]: 1
            };
          }

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            $('.cart-icon')[0].click();
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        });

        $('.option-list').on('init', (event, slick) => {
          var $target = $(event.currentTarget);

          if ($('.option-list').length > 1) {
            if ($target.hasClass('invisible')) {
              setTimeout(() => {
                $target.addClass('inactive')
                $target.removeClass('invisible');
              }, 500);
            }
          } else {
            $target.removeClass('invisible');
          }
        });

        var mobileFirstSlides = ($carousel) => {
          /* Initializes a slick carousel only on mobile screens */
          // slick on mobile
          if (window.matchMedia("(min-width: 601px)").matches) {
            if ($carousel.hasClass('slick-initialized')) {
              $carousel.slick('unslick');
            }
          } else {
            if (!$carousel.hasClass('slick-initialized')) {
              $carousel.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: false,
                draggable:false,
                infinite: true,
                dots: false,
                centerMode: true
              });
            }
          }
        }

        /* Slick needs no get Reinitialized on window Resize after it was destroyed */
        $(window).on('resize orientationchange', function () {
          var $iconSlides = $('.icon-with-text-container');
          mobileFirstSlides($iconSlides);
        });

        mobileFirstSlides($('.icon-with-text-container'));

        $('.option-list').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: false,
          dots: false,
          adaptiveHeight: false,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev"><span class="u-visually-hidden">Previous slide</span><svg width="60" height="61" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30.0498" r="30" fill="#473E39" fill-opacity="0.1"/><path d="M30.7693 20.4498C30.0427 19.7264 28.8676 19.7276 28.1426 20.4527L19.4142 29.181C18.6332 29.9621 18.6332 31.2284 19.4142 32.0095L28.1477 40.743C28.8704 41.4656 30.0412 41.4682 30.767 40.7486V40.7486C31.4973 40.0247 31.4998 38.8451 30.7727 38.118L25.1705 32.5157H39.4659C40.5265 32.5157 41.3864 31.6559 41.3864 30.5953V30.5953C41.3864 29.5346 40.5265 28.6748 39.4659 28.6748H25.1705L30.7711 23.0834C31.4994 22.3563 31.4986 21.1759 30.7693 20.4498V20.4498Z" fill="#473E39"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next"><span class="u-visually-hidden">Next slide</span><svg width="60" height="61" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30.0498" r="30" fill="#473E39" fill-opacity="0.1"/><path d="M30.7693 20.4498C30.0427 19.7264 28.8676 19.7276 28.1426 20.4527L19.4142 29.181C18.6332 29.9621 18.6332 31.2284 19.4142 32.0095L28.1477 40.743C28.8704 41.4656 30.0412 41.4682 30.767 40.7486V40.7486C31.4973 40.0247 31.4998 38.8451 30.7727 38.118L25.1705 32.5157H39.4659C40.5265 32.5157 41.3864 31.6559 41.3864 30.5953V30.5953C41.3864 29.5346 40.5265 28.6748 39.4659 28.6748H25.1705L30.7711 23.0834C31.4994 22.3563 31.4986 21.1759 30.7693 20.4498V20.4498Z" fill="#473E39"/></svg></button>',
          draggable:false,
          infinite: true,
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });

        $('.social-proof-container').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: false,
            dots: false,
            adaptiveHeight: false,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><span class="u-visually-hidden">Previous slide</span><svg width="60" height="61" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30.0498" r="30" fill="#473E39" fill-opacity="0.1"/><path d="M30.7693 20.4498C30.0427 19.7264 28.8676 19.7276 28.1426 20.4527L19.4142 29.181C18.6332 29.9621 18.6332 31.2284 19.4142 32.0095L28.1477 40.743C28.8704 41.4656 30.0412 41.4682 30.767 40.7486V40.7486C31.4973 40.0247 31.4998 38.8451 30.7727 38.118L25.1705 32.5157H39.4659C40.5265 32.5157 41.3864 31.6559 41.3864 30.5953V30.5953C41.3864 29.5346 40.5265 28.6748 39.4659 28.6748H25.1705L30.7711 23.0834C31.4994 22.3563 31.4986 21.1759 30.7693 20.4498V20.4498Z" fill="#473E39"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="u-visually-hidden">Next slide</span><svg width="60" height="61" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30.0498" r="30" fill="#473E39" fill-opacity="0.1"/><path d="M30.7693 20.4498C30.0427 19.7264 28.8676 19.7276 28.1426 20.4527L19.4142 29.181C18.6332 29.9621 18.6332 31.2284 19.4142 32.0095L28.1477 40.743C28.8704 41.4656 30.0412 41.4682 30.767 40.7486V40.7486C31.4973 40.0247 31.4998 38.8451 30.7727 38.118L25.1705 32.5157H39.4659C40.5265 32.5157 41.3864 31.6559 41.3864 30.5953V30.5953C41.3864 29.5346 40.5265 28.6748 39.4659 28.6748H25.1705L30.7711 23.0834C31.4994 22.3563 31.4986 21.1759 30.7693 20.4498V20.4498Z" fill="#473E39"/></svg></button>',
            draggable:false,
            infinite: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });

        $('[aria-describedby="size-guide"]').on('click', (e) => {
          e.preventDefault();

          $(e.target).toggleClass('show_tooltip');
        });

        $('[role="tooltip"] .Icon--close').on('click', (e) => {
          e.preventDefault();

          $('[aria-describedby="size-guide"]').toggleClass('show_tooltip');
        });
      } else {
        console.log("jquery not loaded..");
        window.setTimeout(waitForLoad, 500);
      }
    };
    window.setTimeout(waitForLoad, 500);
  }

  window.onload = loadJQuery;